// 테마 관리. next-themes 없이 document.documentElement 의 `dark` 클래스를 직접 제어하고
// localStorage 에 '선호(preference)'를 저장한다. 'system'이면 OS 설정(prefers-color-scheme)을
// 따르고, OS 변경도 실시간 추적한다. 기본값은 'system'.

const STORAGE_KEY = 'haccp-admin-theme'

export type Theme = 'light' | 'dark' | 'system'

function prefersDark(): boolean {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
}

/** 저장된 테마 선호를 읽는다. 기본은 'system'(OS 설정을 따름). */
export function getStoredTheme(): Theme {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'light' || saved === 'dark' || saved === 'system') {
        return saved
    }
    return 'system'
}

/** 선호를 실제 적용값(light/dark)으로 해석한다. */
export function resolveTheme(pref: Theme): 'light' | 'dark' {
    return pref === 'system' ? (prefersDark() ? 'dark' : 'light') : pref
}

/** 문서에 테마를 적용하고 선호를 저장한다. */
export function applyTheme(pref: Theme) {
    document.documentElement.classList.toggle(
        'dark',
        resolveTheme(pref) === 'dark'
    )
    localStorage.setItem(STORAGE_KEY, pref)
}

let osListenerBound = false

/** 앱 부팅 시 1회 호출. 저장된 선호를 즉시 적용하고, system 모드의 OS 변경을 추적한다. */
export function initTheme(): Theme {
    const pref = getStoredTheme()
    applyTheme(pref)
    if (!osListenerBound) {
        osListenerBound = true
        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', () => {
                // 사용자가 'system'을 쓰는 동안에만 OS 변경을 반영한다.
                if (getStoredTheme() === 'system') {
                    document.documentElement.classList.toggle(
                        'dark',
                        prefersDark()
                    )
                }
            })
    }
    return pref
}
